<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <load v-if="loadingAnterior" mode="table" />
            <div v-else>
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-bold">
                            Acompanhamento Anterior
                        </h4>
                    </div>
                </div>
                 <form
            @submit.prevent="inserirAnterior"
            ref="addItem"
            class="row"
        >
                    <form-select-input
                        v-model="unidade"
                        grid="6"
                        label="Unidade"
                        :itens="unidades"
                        placeholder="Selecione ou digite a unidade"
                        @insert="setUnidade"
                        :required="true"
                    />
                    <form-calendar
                        v-model="data_inicio"
                        grid="3"
                        label="Data de início"
                        :required="true"
                    />
                    <form-calendar
                        v-model="data_fim"
                        grid="3"
                        label="Data Final"
                        :required="true"
                    />
                    <div class="col-12 px-2 text-right">
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Cadastrar") }}
                    </button>
                </div>
                </form>
                <div class="col-12 px-0">
                    <div
                        class="d-flex align-items-center justify-content-between mb-0"
                    >
                        <div>
                            <div class="input-group mb-3">
                                <b-input
                                    :placeholder="$t('Type to search')"
                                    class="form-control search-input"
                                    type="search"
                                    v-model="search"
                                    v-on:change="getListAnteriores"
                                    aria-describedby="input-search"
                                />
                                <div class="input-group-append" role="button">
                                    <span
                                        class="input-group-text"
                                        id="input-search"
                                        ><i class="fas fa-search search-icon"
                                    /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <loading-animation
                            :active.sync="loading"
                            :is-full-page="false"
                            :opacity="1"
                            color="#5895FF"
                        />
                        <b-table
                            :fields="[
                                {
                                    key: 'unidade',
                                    label: $t('Unidade'),
                                },
                                {
                                    key: 'data_inicio',
                                    label: $t('Data Inicio'),
                                },
                                {
                                    key: 'data_fim',
                                    label: $t('Data Fim'),
                                },
                            ]"
                            :items="anteriorList"
                            :responsive="true"
                            striped
                            hover
                            show-empty
                            small
                            outlined
                            stacked="md"
                            table-class="mb-3"
                        >
                            <template v-slot:cell(unidade)="data">
                                {{ data.item.unidade }}
                            </template>
                            <template v-slot:cell(data_inicio)="data">
                                {{ data.item.data_inicio | formatDate}}
                            </template>
                            <template v-slot:cell(data_fim)="data">
                                {{ data.item.data_fim  | formatDate}}
                            </template>
                            <template v-slot:empty="scope">
                                <div class="text-center my-5">
                                    <img
                                        :alt="$t('No results')"
                                        class="mb-5"
                                        src="/img/icons/robot.svg"
                                        style="max-height: 165px"
                                    />
                                    <h3 class="bold">
                                        {{ $t("No records found") }}
                                    </h3>
                                </div>
                            </template>
                        </b-table>

                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="form-group d-inline-flex mb-0">
                                    <select
                                        class="form-control"
                                        style="width: 70px"
                                        v-model="perPage"
                                        @change="getListAnteriores"
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                    </select>
                                </div>
                                <div class="d-inline-flex ml-2">
                                    <b-pagination
                                        :per-page="perPage"
                                        :total-rows="pagination.total"
                                        @change="changePage"
                                        v-model="page"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                                <div class="float-lg-right">
                                    {{ $t("Showing page") }}
                                    {{ pagination.currentPage }}
                                    {{ $t("of") }}
                                    {{ pagination.totalPages }}
                                    {{ $t("pages in") }}
                                    {{ pagination.total }}
                                    {{ $t("records") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["medida"],
    name: "Anterior",
    data() {
        return {
            loadingAnterior: true,
            data_inicial: "",
            data_fim: "",
            unidades: [],
            anteriorList: [],
            unidade: null,
            page: 1,
            search: "",
            perPage: 10,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
        };
    },
    mounted() {
        this.getListAnteriores();
        this.getUnidades();
    },
    methods: {
        getUnidades() {
            axios
                .get(`api/dashboard/unidades/get/externas/medidas`)
                .then((response) => {
                    this.unidades = response.data.map((m)=>{return{id: m.value,value:m.value}});
                });
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getListAnteriores();
            }
        }, setUnidade(item) {
         this.unidade = item;
        },
        getListAnteriores() {
            this.loading = true;
            this.loadingAnterior = true;
            axios
                .post("api/dashboard/medidas/list/anteriores", {
                    id: this.medida.id,
                    page: this.page,
                    search: this.search,
                    perPage: this.perPage,
                })
                .then((response) => {
                    this.anteriorList = response.data.data;
                    this.pagination = response.data.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getListAnteriores();
                    } else {
                        this.loading = false;
                    }
                })
                .finally(() => {
                    this.loadingAnterior = false;
                });
        },
        inserirAnterior() {
            this.loading = true;
            this.loadingAnterior = true;
            axios
                .post("api/dashboard/medida/anterior", {
                    unidade: this.unidade,
                    data_inicio: this.data_inicio,
                    data_fim: this.data_fim,
                    medida_id: this.medida.id,
                })
                .then((response) => {
                    this.getListAnteriores();
                    this.$snack.success({
                        button: false,
                        text: "Cadastrado com sucesso.",
                    });

                    this.loading = false;
                    this.loadingAnterior = false;
                    this.data_fim = "";
                    this.data_inicio = "";
                    this.unidade = "";
                });
        },
    },
};
</script>
<style lang="css">
.list-group-item-action {
    cursor: pointer;
}
</style>
